module.exports = __webpack_public_path__ + "static/assets/2f9a7c50acac4c8b0b6de1a9c603c6cf.gif";